import React, { useRef } from "react";
import "./LocalChalanRasid.css";
import ReactToPrint from "react-to-print";
import { useDispatch, useSelector } from "react-redux";
function LocalChalanRasid({ localChalan }) {
  let componentRef = useRef();
  const profileDetails = useSelector((state) => state.dataReducer.profile);
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  return (
    <div
      className="local-chalan-rasid-container bill"
      id="bill-template"
      style={{ margin: "auto", outline: "1px solid black" }}
    >
      <div
        ref={(el) => (componentRef = el)}
        className="local-chalan-rasid-container "
        style={{ margin: "auto", outline: "1px solid black" }}
      >
        <div className="lch-heading">
          <h2>
            {" "}
            {profileDetails && profileDetails.pro
              ? profileDetails.pro["name"]
              : "---"}
          </h2>
          {/* <p>Transport Contructor & Commission</p> */}
          <h2>
            <u>FREIGHT CHALLAN</u>
          </h2>

          <div className="address">
            <div className="off-address">
              <h2>Office:</h2>
              {/* <p>Near RTO Office , 2-A-10 Ramprasad Ladha Nagar</p>
              <p>Opp Krishan Vihar Colony,Bhilwara-311001 (Raj.)</p>
              <p>Mob No: 8239829889,9923982938</p> */}
              <p>
                {profileDetails && profileDetails.pro
                  ? profileDetails.pro["address"]
                  : "---"}{" "}
              </p>
            </div>
            {/* <div className="branch-address">
              <h4>Barnch Office:</h4>
              <p>Shop No:57,Kutch Aracde</p>
              <p>Near Railway Crossing,Gandhinagar (Kutch)</p>
              <p>Mob No: 8239829889,9923982938</p>
            </div> */}
          </div>
          <hr style={{ width: "100%" }} />
        </div>

        <div className="lch-details">
          <div className="top-header">
            <p>
              <b> Chalan No </b>: {localChalan?.challan_no ?? "---"}
            </p>

            <p>
              <b>Date</b> : {formatDate(localChalan?.date)}
            </p>
          </div>
          <div className="vehicle-number">
            <p>
              <b> Vehicle Number</b> : {localChalan?.truck_no ?? "---"}
            </p>
          </div>
          <div className="owner-address">
            <div style={{ width: "60%" }}>
              <p>
                <b>Owner Name & Address</b> : {localChalan?.owner ?? "---"}
              </p>
            </div>
            <div style={{ width: "40%" }}>
              <p>
                <b>Mobile number</b> : {localChalan?.phone ?? "---"}
              </p>
            </div>
          </div>
          <div className="driver-detail">
            <div style={{ width: "60%" }}>
              <p>
                <b>Driver Name</b> : {localChalan?.driver ?? "---"}
              </p>
            </div>
            <div style={{ width: "40%" }}>
              <p>
                <b>Driver Mobile Number</b> :
                {localChalan?.driver_mobile_number ?? "---"}
              </p>
            </div>
          </div>
          <div className="goods-detail">
            <div style={{ width: "60%" }}>
              <p>
                <b>Goods Loaded From</b> :{" "}
                {localChalan?.goodsLoadedFrom ?? "---"}
              </p>
            </div>
            <div style={{ width: "40%" }}>
              <p>
                <b>To</b> : {localChalan?.goodsLoadedTo ?? "---"}
              </p>
            </div>
          </div>
          <div className="booked-detail">
            <div style={{ width: "60%" }}>
              <p>
                <b>Booked By</b> : {localChalan?.Bookedby ?? "---"}
              </p>
            </div>
            <div style={{ width: "40%" }}>
              <p>
                <b>GR. No</b> : {localChalan?.gr_no ?? "---"}
              </p>
            </div>
          </div>
          <div className="cargo-freight-detail">
            <div style={{ width: "60%" }}>
              <p>
                <b>Bill of Entry Number</b> :{" "}
                {localChalan?.consignment ?? "---"}
              </p>
            </div>
          </div>
          <div className="total-freight-detail">
            <div style={{ width: "30%" }}>
              <p>
                <b>Weight</b> : {localChalan?.weight ?? "---"}
              </p>
            </div>
            <div style={{ width: "20%" }}>
              <p>
                <b>Rate</b> : {localChalan?.rate_per_unit ?? "---"}
              </p>
            </div>
            <p>
              <b>Total Freight</b> : {localChalan?.total_freight ?? "---"}
            </p>
          </div>
          <div className="advanced-freight-detail">
            <p>
              <b>Advance Freight</b> : {localChalan?.advance_amount ?? "---"}
            </p>
          </div>
          <div className="deisel-detail">
            <p>
              <b>Diesel</b> : {localChalan?.diesel ?? "---"}
            </p>
          </div>
          <div className="petrol-pump-name">
            <p>
              <b>Petrol Pump Name</b> : {localChalan?.petrol_pump_name ?? "---"}
            </p>
          </div>
          <div className="commision-detail">
            <p>
              <b>Commmison</b> : {localChalan?.commission ?? "---"}
            </p>
          </div>
          <div className="balalce-freight-detail">
            <p>
              <b>Balance Freight</b> : {localChalan?.balance_freight ?? "---"}
            </p>
          </div>
        </div>

        {/* <div className="terms">
          <ol>
            <li>Rule1</li>
            <li>Rule2</li>
            <li>Rule3</li>
            <li>Rule4</li>
          </ol>
        </div> */}
      </div>
      <div>
        <ReactToPrint
          trigger={() => <button>Print this out!</button>}
          content={() => componentRef}
        />
      </div>
    </div>
  );
}

export default LocalChalanRasid;
